// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__1NlzA","required":"Label_required__1fHYC","sup":"Label_sup__1wH2c"};